import LoginComponent from '@Components/Login';
import { useLocation } from 'react-router-dom';
// import { useTypedSelector } from '@Store/hooks';
// import Curtain from '@Components/Curtain';
// import { motion } from 'framer-motion';

const Login = () => {
  // const openCurtain = useTypedSelector(state => state.curtain.openCurtain);
  const { pathname } = useLocation();

  return (
    <>
      <div
        className={`${pathname === '/sign-up' ? '' : 'lg:naxatw-h-[100vh] '} naxatw-overflow-hidden `}
      >
        {/* {openCurtain ? (
          <div className="naxatw-flex naxatw-h-full naxatw-w-full naxatw-items-center naxatw-justify-center">
            <Curtain />
          </div>
        ) : ( */}
        <LoginComponent />
        {/* )} */}
      </div>
    </>
  );
};

export default Login;
